"use client";

import * as React from "react";
import { Facebook, Linkedin, Twitter, Mail, Instagram, Globe } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section data-section-id="21571" id="footer" className="bg-[#FDFAF3] text-[#1C1917] py-16 font-serif">
      <div className="container mx-auto px-4">
        {}
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-3 lg:gap-8">
          {}
          <div className="lg:col-span-1 flex flex-col gap-6">
            <Link to="/" className="block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587878/img/peoplesync_logo.png" alt="N2N Capital" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-[#1C1917]/70 text-[12px] leading-relaxed font-mono">
              N2N Capital is an AI infrastructure investment platform connecting 
              forward-looking institutional investors with the backbone of 
              artificial intelligence compute.
            </p>
          </div>

          {}
          <div className="lg:col-span-1 flex flex-col gap-4 items-center lg:items-center text-center lg:text-center">
            <h3 className="font-sans font-bold text-[#1C1917] tracking-widest uppercase text-[11px]">
              Links
            </h3>
            <ul className="flex flex-col gap-3">
              <li>
                <Link to="/" className="text-[#1C1917]/60 hover:text-[#B45309] transition-colors text-[12px] font-mono">
                  N2N Capital
                </Link>
              </li>
              <li>
                <Link to="/AboutUsPage" className="text-[#1C1917]/60 hover:text-[#B45309] transition-colors text-[12px] font-mono">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/TheThesisPage" className="text-[#1C1917]/60 hover:text-[#B45309] transition-colors text-[12px] font-mono">
                  The Thesis
                </Link>
              </li>
              <li>
                <Link to="/LeadershipPage" className="text-[#1C1917]/60 hover:text-[#B45309] transition-colors text-[12px] font-mono">
                  Leadership
                </Link>
              </li>
            </ul>
          </div>

        
      
          {}
          <div className="lg:col-span-1 flex flex-col gap-6 lg:items-end lg:text-right">
            <div className="flex items-center gap-4">
              {}
              <Link to="/" className="block">
                <img src="https://decent-kid.10web.cloud/wp-content/uploads/2026/03/N2N.jpeg" alt="N2N Capital" className="h-16 w-auto object-contain rounded-sm" />
              </Link>

              {}
              <div className="flex flex-col gap-4">
                <h3 className="font-sans font-bold text-[#1C1917] tracking-widest uppercase text-[11px]">
                  Terminal
                </h3>
                <div className="flex gap-2">
                  <Button variant="ghost" size="icon" className="h-8 w-8 text-[#1C1917]/60 hover:text-[#B45309] hover:bg-[#B45309]/10 rounded-sm" asChild>
                    <Link to="mailto:info@n2ncapital.com" aria-label="Email">
                      <Mail className="h-4 w-4" />
                    </Link>
                  </Button>
                  <Button variant="ghost" size="icon" className="h-8 w-8 text-[#1C1917]/60 hover:text-[#B45309] hover:bg-[#B45309]/10 rounded-sm" asChild>
                    
                  </Button>
                </div>
              </div>
              
         <div className="flex flex-col gap-2">
                <Select defaultValue="en">
                  
                  <SelectContent className="bg-[#FDFAF3] border-[#1C1917]/10">
                    <SelectItem value="en">Global (EN)</SelectItem>
                    <SelectItem value="es">EU North (ES)</SelectItem>
                    <SelectItem value="fr">EU West (FR)</SelectItem>
                    <SelectItem value="de">EU Central (DE)</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>
          </div>
        </div>

        <Separator className="my-12 bg-[#1C1917]/10" />
             

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 text-[11px] font-mono text-[#1C1917]/60 uppercase tracking-tight">
          <p>© 2026 N2N Capital . All rights reserved.</p>
          <div className="flex flex-wrap justify-center gap-6 items-center">
            <Link to="/PrivacyTermsandDisclaimersPage" className="hover:text-[#B45309] transition-colors">Terms of Use</Link>
            <Link to="/PrivacyPage" className="hover:text-[#B45309] transition-colors">Privacy</Link>
            <div className="flex items-center gap-2 px-3 py-1 border border-[#1C1917]/10 rounded-sm bg-[#F5EDD8]/50">
              <div className="h-1.5 w-1.5 rounded-full bg-[#B45309] animate-pulse" />
              <span className="text-[10px] text-[#B45309]/80">
                System Status: Operational
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}